import React from 'react'
import Image from '../Images/Image'
import LogoGit from "../Images/Github"
import LinkedinIcon from '../Images/LinkedinIcon'

function Card() {
  return (
<div>
 <div className='Card'    >
<div  id='contact'  className="contact"   >  
    <Image />
     <p className="profile-name"  > MAHDI  BEN ALAYA</p>
   <div   className='email_phone' >
    <p    className='email em' style={{fontSize:"17px"}}><i className="fa-solid fa-envelope"></i> EMAIL : mehdibnalaya@gmail.com</p>

   <p > <i className="fa-solid fa-mobile-retro fa-beat fa-lg"></i> <span className='sp' > PHONE : +216 29 499 266</span></p>
   </div>
   <div   className='address'    >
   <p  style={{fontSize:"20px",fontWeight:"bold",margin:'0px'}} >address:</p>
   <p style={{fontSize:"20px",fontWeight:"bold"}}  >Tunis, Tunisia</p>
   </div>
    </div>
<div className="profile-content">
    
    <div className="profile-description" style={{fontSize:"23px",fontWeight:"bold"}}>\\ WEB DEVELOPER //<br/> Full Stack js developer</div>
    <br/> 
  <div >
        <q   style={{fontSize:"21px",fontFamily:"'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif"}}> I am a web
developer specialized in
FULL-STACK JS, I feel comfortable working both independently and as part of a team. My goal is to
continuously enhance my
skills.

</q>
        <br/>
         

      <div className="col-xs-4">
        <div className="profile-overview"  >
        <div>
  <a href="https://github.com/Mahdialaya5"  target="_blank" rel="noreferrer"  ><h4 > github </h4> </a>
</div>

        { <LogoGit/>}
          </div>
          <div className="profile-overview"  >
        <div>
  <a href="https://www.linkedin.com/in/mahdi-ben-alaya-959546251/"  target="_blank" rel="noreferrer"  ><h4 >linkedin</h4> </a>
</div>
<LinkedinIcon/>
          </div>
      </div>
       </div>
  </div>
</div>

    </div>
  )
}

export default Card